import Modal from 'react-modal'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../common/buttons/SubmitButton'
import './InfoModal.scss'

const modalStyles = {
  content: {
    height: 'min-content',
    margin: 'auto',
    maxWidth: '550px',
    marginTop: '12%',
    borderRadius: '8px',
    overflow: 'hidden',
  },
}

const InfoModal = ({
  showModal,
  closeModal,
  icon,
  title,
  children,
  buttonMessage,
  onButtonClick,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={showModal || false}
      onRequestClose={closeModal}
      contentLabel={t('common.infoModal.contentLabel')}
      style={modalStyles}
      autoFocus
    >
      <div id='InfoModal'>
        <div>
          <div className='d-flex justify-content-end text-align-right'>
            <button
              onClick={closeModal}
              className='info-modal-close-button'
            >
              <i className='fa fa-times info-modal-close-icon' />
            </button>
          </div>
          <div className='d-flex flex-column justify-content-center align-items-center info-modal-container'>
            {icon}
            {title && (
              <div className='info-modal-title'>
                <p>{title}</p>
              </div>
            )}
            {children}
          </div>
          <div className='row py-3'>
            <div className='col-12'>
              <SubmitButton
                noTopMargin
                onClick={onButtonClick || closeModal}
                buttonMessage={buttonMessage || t('common.cancel')}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

InfoModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  icon: PropTypes.node,
  title: PropTypes.string,
  children: PropTypes.node,
  buttonMessage: PropTypes.string,
  onButtonClick: PropTypes.func,
}

export default InfoModal
